<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import FontFaceObserver from 'fontfaceobserver';
import { clamp } from 'lodash';

export default {
  name: 'App',

  mounted() {
    this.resize();
    window.addEventListener('resize', this.resize);
    if (
      navigator.userAgent.indexOf('CriOS/') > 0
      && navigator.userAgent.indexOf('AppleWebKit/') > 0
    ) {
      this.preventPullToRefresh(document.body);
    }

    Promise.all([
      new FontFaceObserver('GT America', { weight: 'bold' }).load(),
      new FontFaceObserver('GT America Mono', { weight: 'bold' }).load(),
      new FontFaceObserver('GT America Expanded', { weight: 'bold' }).load(),
    ]).then(() => {
      this.$eventHub.$emit('font-loaded');
    });
  },

  methods: {
    resize() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      // Ratios
      const rw = clamp(window.innerWidth / 1920, 0.25, 1.5);
      const rh = clamp(window.innerHeight / 1080, 0.25, 1.5);
      document.documentElement.style.setProperty('--rw', `${rw}`);
      document.documentElement.style.setProperty('--rh', `${rh}`);
    },

    preventPullToRefresh(element) {
      let prevent = false;
      element.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) return false;
        const scrollY = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
        prevent = (scrollY === 0);
        return false;
      });

      element.addEventListener('touchmove', (event) => {
        if (prevent) {
          prevent = false;
          event.preventDefault();
        }
      }, { passive: false });
    },
  },
};
</script>


<style lang="scss">
@import '@/styles/base.scss';

#app {
  color: $color-light;
  background-color: $color-dark;
  backface-visibility: hidden;
}
</style>
